angular.module('content.widgets.DefaultWidgetService', [
])

/**
 * The DefaultWidgetService service handles scoring and
 * feedback for the state.contentView type
 *
 * @class DefaultWidgetService
 * @constructor
 * @module content.widgets.DefaultWidgetService
 */
.factory('DefaultWidgetService', [
  'EditorService',
  function (EditorService) {
    'use strict';

    var service = {
      getModel: function () {
        return EditorService.getModel();
      }
    };

    return service;
  }
]);
